export default __webpack_public_path__ + "static/media/skovstykket-townhouse-4-rooms-08.fcc1a53b.jpg";